import { useTranslation } from "next-i18next";
import { size } from "../../../../../constants";
import { useWindowSize } from "../../../../../hooks/useWindowResize";
import { cn } from "../../../../../lib/utils";
import { Button } from "../../../casos/components/Button";
import { Line } from "../../../casos/components/Line";
import { Subtitle } from "../../../casos/components/Subtitle";
import { Text } from "../../../casos/components/Text";
import { useProducts } from "../../hooks/useProducts";

function Cta() {
	const { t } = useTranslation();
	const { scrollToContactForm } = useProducts();

	return (
		<Button
			onClick={scrollToContactForm}
			className="bg-vivid-03 text-neutral-08 hover:text-neutral-700 laptop:min-w-[480px] min-w-[342px]"
		>
			{t("products.squad-ia.methodology.ctaButton")}
		</Button>
	);
}

function StepMethodology({ position, title, description }) {
	return (
		<div
			className={cn(
				[
					"before:content-[''] before:absolute has-[+div]:before:block before:hidden",
					"before:h-full before:border-l-[3px] before:top-[64px] before:left-[32px] before:border-vivid-03",
					"laptop:before:top-[80px] laptop:before:left-[40px]",
				],
				"flex relative gap-4",
				"laptop:gap-6",
				"",
			)}
		>
			<div
				className={cn(
					"border-vivid-03 border-[3px] text-vivid-03 flex items-center justify-center rounded-full bg-neutral-07",
					"text-[32px] leading-[48px] laptop:text-[40px]",
					"laptop:h-[80px] laptop:min-w-[80px] h-[64px] min-w-[64px]",
				)}
			>
				{position}
			</div>
			<div>
				<p
					className={cn(
						"font-medium text-white text-xl leading-8",
						"laptop:text-2xl",
					)}
				>
					{title}
				</p>
				<p
					className={cn(
						"text-neutral-02 mt-2 text-lg leading-[30px]",
						"laptop:text-xl laptop:leading-8 laptop:mt-4",
					)}
				>
					{description}
				</p>
			</div>
		</div>
	);
}

export function MethodologySection() {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const isLaptop = width >= size.laptopL;

	return (
		<section className="bg-neutral-07">
			<div className="!py-10 container-blog laptop:!py-14">
				<div
					className={cn(
						"flex flex-col w-full gap-10",
						"laptopL:gap-14 laptopL:flex-row",
					)}
				>
					<div className="shrink-0 grow-0 laptopL:basis-[530px]">
						<Line className="mx-auto border-vivid-03 laptop:mx-0" />

						<Subtitle
							className={cn(
								"text-white text-center font-medium mt-6 mb-4 max-w-[530px] mx-auto",
								"laptop:text-left laptop:mx-0 laptop:max-w-max",
								"laptopM:max-w-[530px]",
							)}
						>
							<h3>{t("products.squad-ia.methodology.title")}</h3>
						</Subtitle>

						<Text
							className={cn(
								"text-white text-center max-w-[470px] mx-auto",
								"laptop:text-left laptop:mx-0 laptop:max-w-[880px]",
								"laptopM:max-w-[470px]",
							)}
						>
							{t("products.squad-ia.methodology.description")}
						</Text>

						{isLaptop && (
							<div className="mt-10">
								<Cta />
							</div>
						)}
					</div>

					<div className="relative flex-1 space-y-10 laptop:space-y-14">
						<StepMethodology
							position="01"
							description={t(
								"products.squad-ia.methodology.steps.modularIntelligence.description",
							)}
							title={t(
								"products.squad-ia.methodology.steps.modularIntelligence.title",
							)}
						/>

						<StepMethodology
							position="02"
							description={t(
								"products.squad-ia.methodology.steps.intelligentOrchestration.description",
							)}
							title={t(
								"products.squad-ia.methodology.steps.intelligentOrchestration.title",
							)}
						/>

						<StepMethodology
							position="03"
							description={t(
								"products.squad-ia.methodology.steps.adaptiveAutonomy.description",
							)}
							title={t(
								"products.squad-ia.methodology.steps.adaptiveAutonomy.title",
							)}
						/>
					</div>

					{!isLaptop && (
						<div className="mx-auto">
							<Cta />
						</div>
					)}
				</div>
			</div>
		</section>
	);
}
